import { Link } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'

import { tr } from 'mmfintech-commons'
import { useBanksRequest } from 'mmfintech-checkout-commons'

import SelectBankPane from '@components/SelectBankPane'

import { ErrorDisplay, Input } from 'mmfintech-portal-commons'
import { BackIcon, SearchIcon } from '@icons'

import type { UseAdditionalFieldsOutput } from 'mmfintech-checkout-commons/types'

type SelectBankStepProps = {
  backCaption: string
  backVisible: boolean
  onBack: () => void
  paymentMethod: string
  fieldValues: UseAdditionalFieldsOutput
  filteredBanks: any
  countryCode: string
  onContinue: () => void
  cancelVisible: boolean
  onCancel: () => void
  handleSearchFocus: () => void
  handleSearchType: () => void
}

export const SelectBankStep = (props: SelectBankStepProps) => {
  const {
    backCaption,
    backVisible,
    onBack,
    paymentMethod,
    fieldValues,
    filteredBanks,
    countryCode,
    onContinue,
    cancelVisible,
    onCancel,
    handleSearchFocus,
    handleSearchType
  } = props

  const { checkoutPayError, checkoutPayFetching } = useSelector(
    ({ checkout: { checkoutPayError, checkoutPayFetching } }) => ({
      checkoutPayError,
      checkoutPayFetching
    }),
    shallowEqual
  )

  const { banksCount, banksLoaded } = useBanksRequest()

  return (
    <div>
      {backVisible ? (
        <div className='back-button-wrapper'>
          <span onClick={onBack} data-test='back-button'>
            <BackIcon />
            <span>{backCaption}</span>
          </span>
        </div>
      ) : null}

      {paymentMethod ? (
        <div className='payment-method-wrapper' data-test={`pay-with-${paymentMethod}-banks`}>
          {tr('CHECKOUT.PAYMENT.PAY_BY', 'Pay with {{METHOD}}', {
            METHOD: tr(`METADATA.PAYMENT_OPTIONS.${paymentMethod}`, paymentMethod)
          })}
        </div>
      ) : null}

      <ErrorDisplay error={checkoutPayError} />

      {banksCount > 10 ? (
        <div className='bank-search'>
          <SearchIcon />
          <Input
            key='bank-search'
            type='text'
            name='bank-search'
            data-test='bank-search-input'
            maxLength={50}
            value={filteredBanks.bankSearchText}
            onChange={(_name: string, value: string) => {
              filteredBanks.setBankSearchText(value)
              if (value?.length) {
                handleSearchType()
              }
            }}
            onFocus={handleSearchFocus}
            placeholder={
              countryCode === 'DEU'
                ? tr('CHECKOUT.PAYMENT.BANK_SEARCH_DEU', 'Search by bank name or BLZ')
                : tr('CHECKOUT.PAYMENT.BANK_SEARCH', 'Search by bank name')
            }
            hideErrorLine
            autoComplete='off'
          />
        </div>
      ) : null}

      <SelectBankPane
        banksLoaded={banksLoaded}
        filteredBanks={filteredBanks}
        selectedBankId={fieldValues.getValue('bankChoiceId')}
        onContinue={onContinue}
        loading={checkoutPayFetching}
      />

      <div className='buttons'>
        {cancelVisible ? (
          <div className='cancel-button-container'>
            <Link to='#' onClick={onCancel} data-test='cancel-button'>
              {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  )
}
